const AUTH_CODES = {
    A001: 'WRONG_PASSWORD',
    A010: 'COMPANY_NOT_ASSIGNED',
};

export default AUTH_CODES;
